import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    PreguntaInstalacion: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_PREGUNTAS_INSTALACIONES = 'GET_ALL_PREGUNTAS_INSTALACIONES'
const GET_PREGUNTA_INSTALACION_BY_ID = 'GET_PREGUNTA_INSTALACION_BY_ID'
const GET_PREGUNTA_INSTALACION_BY_ID_TIPO_INSTALACION = 'GET_PREGUNTA_INSTALACION_BY_ID_TIPO_INSTALACION'
const POST_PREGUNTA_INSTALACION = 'POST_PREGUNTA_INSTALACION'
const UPDATE_PREGUNTA_INSTALACION = 'UPDATE_PREGUNTA_INSTALACION'
const DELETE_PREGUNTA_INSTALACION = 'DELETE_PREGUNTA_INSTALACION'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllPreguntasInstalaciones = createAsyncThunk(
    GET_ALL_PREGUNTAS_INSTALACIONES,
    async () => {
        try {
            const fullUrl = host + `PreguntaInstalacion/obtenerPreguntasInstalacion`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las PreguntaInstalacions: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getPreguntaInstalacionById = createAsyncThunk(
    GET_PREGUNTA_INSTALACION_BY_ID,
    async (idPreguntaInstalacion) => {
        try {
            const fullUrl = host + `PreguntaInstalacion/obtenerPreguntaInstalacionById/${idPreguntaInstalacion}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getPreguntaInstalacionByIdTipoInstalacion = createAsyncThunk(
    GET_PREGUNTA_INSTALACION_BY_ID_TIPO_INSTALACION,
    async (idTipoInstalacion) => {
        try {
            const fullUrl = host + `PreguntaInstalacion/obtenerPreguntaInstalacionByIdTipoInstalacion/${idTipoInstalacion}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertPreguntaInstalacion = createAsyncThunk(
    POST_PREGUNTA_INSTALACION,
    async (data) => {
        try {
            const fullUrl = host + `PreguntaInstalacion/agregarPreguntaInstalacion`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updatePreguntaInstalacion = createAsyncThunk(
    UPDATE_PREGUNTA_INSTALACION,
    async (data) => {
        try {
            const fullUrl = host + `PreguntaInstalacion/actualizarPreguntaInstalacion`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deletePreguntaInstalacion = createAsyncThunk(
    DELETE_PREGUNTA_INSTALACION,
    async (idPreguntaInstalacion) => {
        try {
            const fullUrl = host + `PreguntaInstalacion/eliminarPreguntaInstalacion/${idPreguntaInstalacion}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosPreguntaInstalacionSlice = createSlice({

    name: 'metodosPreguntaInstalacionSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllPreguntasInstalaciones.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.PreguntaInstalacion = payload.data.data

        },
        [getPreguntaInstalacionById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.PreguntaInstalacion = payload.data.data
        },
        [getPreguntaInstalacionByIdTipoInstalacion.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.PreguntaInstalacion = payload.data.data
        },
        [insertPreguntaInstalacion.fulfilled]: (state, { payload }) => {
            state.PreguntaInstalacion = payload.data.data
        },

        [updatePreguntaInstalacion.fulfilled]: (state, { payload }) => {

        },
        [deletePreguntaInstalacion.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosPreguntaInstalacionSlice.actions
export const PreguntaInstalacionReducer = metodosPreguntaInstalacionSlice.reducer